import React, { useState } from "react";
import "./TechStack.css"; // Assuming the CSS styles are saved in App.css

const cardsData = [
  {
    title: "Frontend Development",
    description: "Technologies used for building user interfaces.",
    details: `React for dynamic UIs, HTML & CSS for layout and styling, Bootstrap for responsive design and UI components.`,
  },
  {
    title: "Backend Development",
    description: "Technologies used for server-side development and APIs.",
    details: `Flask for building lightweight, scalable web applications and APIs.`,
  },
  {
    title: "Database Management",
    description: "Databases store and manage application data.",
    details: `Microsoft SQL Server (MSSQL) for database management, executing complex queries, and maintaining data integrity.`,
  },
  {
    title: "Security & Networking",
    description: "Tools used for monitoring and enhancing network security.",
    details: `Suricata for intrusion detection, network monitoring, and security analytics.`,
    },
  {
    title: "Operating System",
    description: "Environment and OS tools used for development and security tasks.",
    details: `Kali Linux for penetration testing, network security, and ethical hacking tasks.
              npm (Node Package Manager) for managing JavaScript dependencies in React projects.`,
  },
];


const Dashboard = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <div className="dashboard">
      <div id="particle-container"></div>
      <div className="techcontent">
        {cardsData.map((card, index) => (
          <div
            className={`card ${expandedCard === index ? "expanded" : ""}`}
            onClick={() => toggleCard(index)}
            key={index}
          >
            <h3>{card.title}</h3>
            <p>
            {card.description}
            </p>
            <p>{card.brief}</p>
            <div className="collapse-content">
              <p>{card.details}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
